import { HasPermission } from "#common/Funciones"
import { PERFILES } from "../../../Constants/Strings"
import { useSolicitudesContext } from "../Solicitudes/SolicitudesContext"

export default function IsGuatemala() {
	const { sucursal } = useSolicitudesContext()

	if (
		HasPermission(PERFILES.GUATEMALA, true) ||
		sucursal === "Guatemala" ||
		sucursal === "Xela"
	)
		return { have: true }

	return { have: false }
}

export const GT_ESTADOS = [
	{ clave: "160", nombre: "Alta Verapaz" },
	{ clave: "150", nombre: "Baja Verapaz" },
	{ clave: "200", nombre: "Chimaltenango" },
	{ clave: "040", nombre: "Chiquimula" },
	{ clave: "010", nombre: "Guatemala" },
	{ clave: "020", nombre: "El Progreso" },
	{ clave: "050", nombre: "Escuintla" },
	{ clave: "130", nombre: "Huehuetenango" },
	{ clave: "180", nombre: "Izabal" },
	{ clave: "210", nombre: "Jalapa" },
	{ clave: "220", nombre: "Jutiapa" },
	{ clave: "170", nombre: "Petén" },
	{ clave: "090", nombre: "Quetzaltenango" },
	{ clave: "104", nombre: "Quiché" },
	{ clave: "110", nombre: "Retalhuleu" },
	{ clave: "030", nombre: "SACATEPÉQUEZ" },
	{ clave: "120", nombre: "San Marcos" },
	{ clave: "060", nombre: "Santa Rosa" },
	{ clave: "070", nombre: "Sololá" },
	{ clave: "100", nombre: "Suchitepequez" },
	{ clave: "080", nombre: "Totonicapán" },
	{ clave: "180", nombre: "Zacapa" },
]
export const GT_MUNICIPIOS = {
	"010": [
		"Municipio de Guatemala",
		"Santa Catarina Pinula",
		"San José Pinula",
		"San José del Golfo",
		"Palencia",
		"Chinautla",
		"San Pedro Ayampuc",
		"Mixco",
		"San Pedro Sacatepéquez",
		"San Juan Sacatepéquez",
		"San Raimundo",
		"Chuarrancho",
		"Fraijanes",
		"Amatitlán",
		"Villa Nueva",
		"Villa Canales",
		"Petapa",
	],
	"020": [
		"Guastatoya",
		"Morazán",
		"San Agustín Acasaguastlán",
		"San Cristobal Acasaguastlán",
		"El Jícaro",
		"Sansare",
		"Sanarate",
		"San Antonio La Paz",
	],
	"030": [
		"Antigua Guatemala",
		"Jocotenango",
		"Pastores",
		"Sumpango",
		"Santo Domingo Xenacoj",
		"Santiago Sacatepéquez",
		"San Bartolomé Milpas Altas",
		"San Lucas Sacatepéquez",
		"Santa Lucia Milpas Altas",
		"Magdalena Milpas Altas",
		"Santa María de Jesus",
		"Ciudad Vieja",
		"San Miguel Dueñas",
		"Alotenango",
		"San Antonio Aguas Calientes",
		"Santa Catalina Barahona",
	],
	"040": [
		"Chimaltenango",
		"San José Poaquil",
		"San MartÍn Jilotepeque",
		"Comalapa",
		"Santa Apolonia",
		"Tecpan Guatemala",
		"Patzun",
		"Pochuta",
		"Patzicía",
		"Santa Cruz Balanya",
		"Acatenango",
		"Yepocapa",
		"San Andrés Itzapa",
		"Parramos",
		"Zaragoza",
		"El Tejar",
	],
	"050": [
		"Escuintla",
		"Santa Lucía Cotzumalguapa",
		"La Democracia",
		"Siquinala",
		"Masagua",
		"Tiquisate",
		"La Gomera",
		"Guanagazapa",
		"San José",
		"Iztapa",
		"Palín",
		"San Vicente Pacaya",
		"Nueva Concepción",
	],
	"060": [
		"Cuilapa",
		"Barberena",
		"Santa Rosa De Lima",
		"Casillas",
		"San Rafael Las Flores",
		"Oratorio",
		"San Juan Tecuaco",
		"Chiquimulilla",
		"Taxisco",
		"Santa María Ixhuatan",
		"Guazacapan",
		"Santa Cruz Naranjo",
		"Pueblo Nuevo Viñas",
		"Nueva Santa Rosa",
	],
	"070": [
		"Sololá",
		"San José Chacayá",
		"Santa María Visitación",
		"Santa Lucía Utatlan",
		"Nahuala",
		"Santa Catarina Ixtahuacan",
		"Santa Clara La Laguna",
		"Concepción",
		"San Andrés Semetabaj",
		"Panajachel",
		"Santa Catarina Palopó",
		"San Antonio Palopó",
		"San Lucas Tolimán",
		"Santa Cruz La Laguna",
		"San Pablo La Laguna",
		"San Marcos La Laguna",
		"San Juan La Laguna",
		"San Pedro La Laguna",
		"Santiago Atitlán",
	],
	"080": [
		"Totonicapán",
		"San Cristóbal Totonicapan",
		"San Francisco El Alto",

		"San Andrés Xecul",
		"Momostenango",
		"Santa María Chiquimula",
		"Santa Lucía La Reforma",
		"San Bartolo",
	],
	"090": [
		"Quetzaltenango",
		"Salcajá",
		"Olintepeque",
		"San Carlos Sija",
		"Sibilia",
		"Cabricán",
		"Cajolá",
		"San Miguel Siguilá",
		"Ostuncalco",
		"San Mateo",
		"Concepción Chiquirichapa",
		"San Martín Sacatepéquez",
		"Almolonga",
		"Cantel",
		"Huitán",
		"Zunil",
		"Colomba",
		"San Francisco La Unión",
		"El Palmar",
		"Coatepeque",
		"Génova",
		"Flores Costa Cuca",
		"La Esperanza",
		"Palestina de Los Altos",
	],
	100: [
		"Mazatenango",
		"Cuyotenango",
		"San Francisco Zapotitlán",
		"San Bernardino",
		"San José El Idolo",
		"Santo Domingo Suchitepéquez",
		"San Lorenzo",
		"Samayac",
		"San Pablo Jocopilas",
		"San Antonio Suchitepéquez",
		"San Miguel Panán",
		"San Gabriel",
		"Chicacao",
		"Patulul",
		"Santa Barbara",
		"San Juan Bautista",
		"Santo Tomás La Unión",
		"Zunilito",
		"Pueblo Nuevo",
		"Río Bravo",
	],
	110: [
		"Retalhuleu",
		"San Sebastián",
		"Santa Cruz Muluá",
		"San Martín Zapotitlán",
		"San Felipe",
		"San Andrés Villa Seca",
		"Champerico",
		"Nuevo San Carlos",
		"El Asintal",
	],
	120: [
		"San Marcos",
		"San Pedro Sacatepéquez",
		"San Antonio Sacatepéquez",
		"Comitancillo",
		"San Miguel Ixtahuacán",
		"Concepción Tutuapa",
		"Tacaná",
		"Sibinal",
		"Tajumulco",
		"Tejutla",
		"San Rafael Pie De La Cuesta",
		"Nuevo Progreso",
		"El Tumbador",
		"El Rodeo",
		"Malacatán",
		"Catarina",
		"Ayutla",
		"Ocós",
		"San Pablo",
		"El Quetzal",
		"La Reforma",
		"Pajapita",
		"Ixchiguán",
		"San José Ojetenam",
		"San Cristóbal Cucho",
		"Sipacapa",
		"Esquipulas Palo Gordo",
		"Río Blanco",
		"San Lorenzo",
	],
	130: [
		"Huehuetenango",
		"Chiantla",
		"Malacatancito",
		"Cuilco",
		"Nentón",
		"San Pedro Necta",
		"Jacaltenango",
		"Soloma",
		"Ixtahuacán",
		"Santa Bárbara",

		"La Libertad",
		"La Democracia",
		"San Miguel Acatán",
		"San Rafael La Independencia",
		"Todos Santos Cuchumatánes",
		"San Juan Atitán",
		"Santa Eulalia",
		"San Mateo Ixtatán",
		"Colotenango",
		"San Sebastián Huehetenango",
		"Tectitán",
		"Concepción Huista",
		"San Juan Ixcoy",
		"San Antonio Huista",
		"San Sebastián Coatán",
		"Barillas",
		"Aguacatán",
		"San Rafael Petzal",
		"San Gaspar Ixchil",
		"Santiago Chimaltenango",
		"Santa Ana Huista",
	],
	140: [
		"Santa Cruz del Quiché",
		"Chiché",
		"Chinique",
		"Zacualpa",
		"Chajul",
		"Chichicastenango",
		"Patzité",
		"San Antonio Ilotenango",
		"San Pedro Jocopilas",
		"Cunén",
		"San Juan Cotzal",
		"Joyabaj",
		"Nebaj",
		"San Andrés Sajcabajá",
		"Uspantán",
		"Sacapulas",
		"San Bartolomé Jocotenango",
		"Canillá",
		"Chicamán",
		"Ixcán",
		"Pachalum",
	],
	150: [
		"Salamá",
		"San Miguel Chicaj",
		"Rabinal",
		"Cubulco",
		"Granados",
		"Santa Cruz El Chol",
		"San Jerónimo",
		"Purulha",
	],
	160: [
		"Cobán",
		"Santa Cruz Verapaz",
		"San Cristóbal Verapaz",
		"Tactic",
		"Tamahú",
		"Tucurú",
		"Panzos",
		"Senahú",
		"San Pedro Carchá",
		"San Juan Chamelco",
		"Lanquín",
		"Santa María Cahabón",
		"Chisec",
		"Chahal",
		"Fray Bartolomé de las Casas",
		"La Tinta",
		"Raxruhá",
	],
	170: [
		"Flores",
		"San José",
		"San Benito",
		"San Andrés",
		"La Libertad",
		"San Francisco",
		"Santa Ana",
		"Dolores",
		"San Luis",
		"Sayaxché",
		"Melchor de Mencos",
		"Poptún",
		"Las Cruces",
		"San José",
		"La Libertad",
	],
	180: ["Puerto Barrios", "Livingston", "El Estor", "Morales", "Los Amates"],
	190: [
		"Zacapa",
		"Estanzuela",
		"Río Hondo",
		"Gualán",
		"Teculután",
		"Usumatlán",
		"Cabañas",
		"San Diego",
		"La Unión",
	],
	200: [
		"Chiquimula",
		"San José La Arada",

		"San Juan Ermita",
		"Jocotán",
		"Camotán",
		"Olopa",
		"Esquipulas",
		"Concepción Las Minas",
		"Quezaltepeque",
		"San Jacinto",
	],
	210: [
		"Jalapa",
		"San Pedro Pinula",
		"San Luis Jilotepeque",
		"San Manuel Chaparrón",
		"San Carlos Alzatate",
		"Monjas",
		"Mataquescuintla",
	],
	220: [
		"Jutiapa",
		"El Progreso",
		"Santa Catarina Mita",
		"Agua Blanca",
		"Asunción Mita",
		"Yupiltepeque",
		"Atescatempa",
		"Jerez",
		"El Adelanto",
		"Zapotitlán",
		"Comapa",
		"Jalpatagua",
		"Conguaco",
		"Moyuta",
		"San José Acatempa",
		"Quesada",
	],
}
